export default "__VITE_ASSET__CNRbRSAV__"